<template>
  <div class="product-grid-wrapper">
    <!-- Loading State -->
    <div v-if="loading" class="text-center" style="padding: 3rem 0;">
      <div class="loading-spinner" style="margin: 0 auto;"></div>
      <p class="text-muted mt-4">กำลังโหลดสินค้า...</p>
    </div>

    <!-- Empty State -->
    <div v-else-if="!products.length" class="empty-state">
      <svg class="empty-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-4.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 009.586 13H7"/>
      </svg>
      <h3 class="empty-title">ไม่พบสินค้า</h3>
      <p class="empty-desc">{{ emptyMessage }}</p>
      <button v-if="showResetButton" @click="resetFilters" class="btn btn-primary">
        ล้างตัวกรอง
      </button>
    </div>

    <!-- Product Grid -->
    <div v-else class="products-grid">
      <ProductCard
        v-for="product in products"
        :key="product.id"
        :product="product"
        @add-to-cart="handleAddToCart"
      />
    </div>
  </div>
</template>

<script setup>
import ProductCard from './ProductCard.vue';

const props = defineProps({
  products: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  },
  emptyMessage: {
    type: String,
    default: 'ไม่มีสินค้าในหมวดหมู่นี้'
  },
  showResetButton: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['add-to-cart', 'reset-filters']);

const handleAddToCart = (product) => {
  emit('add-to-cart', product);
};

const resetFilters = () => {
  emit('reset-filters');
};
</script>

<style scoped>
.product-grid-wrapper {
  width: 100%;
}

.empty-state {
  text-align: center;
  padding: 4rem 1rem;
}

.empty-icon {
  width: 4rem;
  height: 4rem;
  margin: 0 auto 1rem;
  color: var(--color-text-muted);
}

.empty-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 0.5rem;
}

.empty-desc {
  color: var(--color-text-light);
  margin-bottom: 1.5rem;
}
</style>
